var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c("v-tab", [_c("h6", [_vm._v("Organizations")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Infrastructure")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Endpoints")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Users")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Configs")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Worker Sessions")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Audit History")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Integration Tokens")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Org Approvals")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Datafeed")])]),
              _vm._v(" "),
              _c("v-tab", [_c("h6", [_vm._v("Type Codes")])]),
              _vm._v(" "),
              _c("v-tab-item", [_c("co-orgs")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("co-systems")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("co-endpoints")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("co-users")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("co-app-configs")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("co-worker-sessions")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("audit-history")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("integration-tokens")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("org-approvals")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("datafeed")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("type-codes")], 1),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }